import type { Slide } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

import { BaseSceneSwapBridge } from 'js/src/libs/scene-swapping/BaseBridge';

export class TalkingHeadInsertToCommonBridge extends BaseSceneSwapBridge {
    override _from = VideoData.CATEGORY_TALKING_HEAD_INSERT;
    override _to = VideoData.CATEGORY_COMMON;

    override _isSwapAllowedFor(originalScene: Slide): boolean {
        // you can always swap a talking head insert scene to a common scene
        return true;
    }
}
